//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const init = {
  openDiffModal: false,
};

export const UI = (state = init, action) => {
  switch (action.type) {
    case ActionTypes.updateUI.update:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
